import moment from 'moment';

export const obterMesDaCompetencia = (competencia, split) => Number(competencia.split(split)[0]);

export const obterAnoDaCompetencia = (competencia, split) => Number(competencia.split(split)[1]);

export const formatarMoedaParaBackend = valor => parseFloat(valor.replace(/\./g, '').replace(',', '.'));

export const pad = (n, width, z) => {
  const z1 = z || '0';
  const n1 = `${n}`;
  return n1.length >= width ? n1 : new Array((width - n1.length) + 1).join(z1) + n1;
};

const deveRemover = (keep, f) => !(f === keep || !f.startsWith('filtro'));

export const manterApenasFiltro = (keep) => {
  // Remove todos os filtros, exceto "keep".
  // Mantem objetos que não são filtros
  const toRemove = Object.keys(sessionStorage).filter(f => deveRemover(keep, f));
  toRemove.forEach(f => sessionStorage.removeItem(f));
};

export const habilitarUploadNaConsultaDoRequerimento = (requerimento, acao, temBloqueioAtivoContratoDtp) => {
  let retorno = false;
  if (requerimento) {
    let solicitanteRGPS = requerimento.solicitante && requerimento.solicitante.codigo === '01000';
    if (solicitanteRGPS === undefined) {
      solicitanteRGPS = false;
    }
    let solicitanteRPPS = requerimento.solicitante && requerimento.solicitante.codigo !== '01000';
    if (solicitanteRPPS === undefined) {
      solicitanteRPPS = false;
    }
    const isConsulta = ['consulta'].includes(acao);
    const isEstadosHabilitados = [1, 2, 4, 5, 7, 13].includes(requerimento.estado);
    let temBloqueio = false;
    if (temBloqueioAtivoContratoDtp !== null) {
      temBloqueio = temBloqueioAtivoContratoDtp;
    } else {
      temBloqueio = false;
    }
    retorno = (solicitanteRGPS || solicitanteRPPS) && isEstadosHabilitados && isConsulta && !temBloqueio;
    return retorno;
  }
  return retorno;
};

export const ehPapelObservadorRelatorio = papelUsuarioLogado => (
  (['auditor-comprev', 'analista-dtp', 'analista-sprev'].includes(papelUsuarioLogado))
);

export const ehPapelObservadorPagamento = papelUsuarioLogado => (
  (['auditor-comprev', 'analista-dtp', 'analista-sprev'].includes(papelUsuarioLogado))
);

export const stringToData = texto => (
  moment(texto, 'DD/MM/YYYY').toDate()
);

export const stringToDateTime = texto => (
  moment(texto, 'DD/MM/YYYY').toDate().getTime
);

// https://momentjscom.readthedocs.io/en/latest/moment/03-manipulating/01-add/
export const adicionarQuantidadeAumaData = (data, quantidade, unidadeDeTempo) => (
  moment(data).add(quantidade, unidadeDeTempo)
);

export const formatarValor = (valor) => {
  let valorFormatado = '0.0';
  if ((valor !== undefined) && (valor !== null)) {
    const formato = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 3,
      style: 'currency',
      currency: 'BRL',
    };
    if (valor === 0 || valor === '') {
      return 'R$ 0,00';
    }
    valorFormatado = valor.toLocaleString('pt-BR', formato);
  }
  return valorFormatado;
};

export const formatarCnpj = (cnpj) => {
  if (!cnpj) return '';
  const cnpjLimpo = cnpj.replace(/[.\-/]/g, '');
  return cnpjLimpo.replace(/([A-Za-z0-9]{2})([A-Za-z0-9]{3})([A-Za-z0-9]{3})([A-Za-z0-9]{4})([A-Za-z0-9]{2})/, '$1.$2.$3/$4-$5');
};



// WEBPACK FOOTER //
// ./src/utils/helpers.js